<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-chart-line"></i>
          Welcome
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Welcome</a>
          </li>
      </ul>
    </div>
    <b-card>
      <b-row class="text-center" style="font-size: 1.45rem;">
        <b-col md="4">
          <b style="color : #3D63BA">分析期間 :</b>
          <b> {{'最終時間から24時間' }}</b>
        </b-col>
        <b-col md="4">
          <b style="color : #3D63BA">リフレッシュ期間: {{refresh}}</b>
          <b> 分</b>
        </b-col>
        <b-col md="4">
          <b style="color : #3D63BA">セキュリティリスクレベル : </b>
          <b-badge v-if="UWSS_status == 2" variant="danger">危険</b-badge>
          <b-badge v-else-if="UWSS_status == 1" variant="warning">注意</b-badge>
          <b-badge v-else variant="success">安全</b-badge>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mb-1">
      <b-row>
        <b-col md="1" sm="1" xl="1"></b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="dark">&nbsp;&nbsp;&nbsp;</b-badge> <b> 相関分析</b>
        </b-col>
        <b-col>
          相関とは、部分的な悪意ある攻撃があることを示します。
        </b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="danger">&nbsp;&nbsp;&nbsp;</b-badge> <b> 危険</b>
        </b-col>
        <b-col>
          Web攻撃の成功、インシデントの予兆、セキュリティチェックの必要性
        </b-col>

      </b-row>
      <b-row>
        <b-col md="1" sm="1" xl="1"></b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="warning">&nbsp;&nbsp;&nbsp;</b-badge> <b> 注意</b>
        </b-col>
        <b-col>
          Web攻撃発生、要注意
        </b-col>
        <b-col md="2" sm="2" xl="2">
          <b-badge variant="success">&nbsp;&nbsp;&nbsp;</b-badge> <b> 安全</b>
        </b-col>
        <b-col>
          Web攻撃やセキュリティインシデントの兆候はない
        </b-col>
      </b-row>
        <!-- <b-badge variant="warning">&nbsp;&nbsp;&nbsp;</b-badge> <b> 注意</b>
          <p>Web攻撃発生、要注意</p>
        <b-col>
          <b-row>
            <b-col md="4">
              <b-badge variant="danger">&nbsp;&nbsp;&nbsp;</b-badge> <b> 危険</b>
            </b-col>
            <pre>Web攻撃の成功、インシデントの兆候<br>Web攻撃の兆候はないが、インシデントが発生する</pre>
          </b-row>
        </b-col> -->
        <!-- <b-col>
          <b-row>
            <b-badge variant="warning">&nbsp;&nbsp;&nbsp;</b-badge> <b> 注意</b>
            <p>Web攻撃発生、要注意</p>
            <b-col md="4">

            </b-col>
            <b-col md="4">

            </b-col>
          </b-row>
        </b-col> -->
        <!-- <b-col>
          <b-row>
            <b-col md="4">
              <b-badge variant="success">&nbsp;&nbsp;&nbsp;</b-badge> <b> 安全</b>
            </b-col>
            <pre>Web攻撃やセキュリティインシデントの兆候はない</pre>
          </b-row>
        </b-col> -->
      <!-- </b-row> -->
    </b-card>
    <!-- TODO : 연계 분석은 2021.06 배포 ( https://its.f1security.co.kr/issues/3292 ) -->
    <hr v-if="UWSS_analysis.length > 0">
    <b-row v-if="UWSS_analysis.length > 0">
      <b-col>
        <b-card v-if="UWSS_analysis.length > 0">
          <center>
            Webセキュリティ対策の統一化の状況
          </center>
          <hr>
          <b-row class="row justify-content-center">
            <correlaction  v-for="(info, index) in UWSS_analysis" :hot="hot" v-bind:key="index" :info="info" :wc_pong_list="wc_pong_list" :wsf_pong_list="wsf_pong_list"></correlaction>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <center> Webセキュリティサービスの個別対応状況 </center>
    <hr>
    <b-row>
      <b-col v-if="auth && auth.license && auth.license.WEBCastle.use == true">
        <b-card>
          <center>
            Webハッキング攻撃対策 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'webcastle_log' })">WEBCastle</span>)
          </center>
          <hr>
          <b-row class="row justify-content-center">
            <webcastle-item  v-for="dashboard_wc in WC" :key="dashboard_wc.index" :wc="dashboard_wc" :wc_pong_list="wc_pong_list"></webcastle-item>
          </b-row>
        </b-card>
      </b-col>
      <b-col v-if="auth && auth.license && auth.license.WSFinder.use == true">
        <b-card>
          <center>
            WebShellのインストール保護 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'wsfinder_detect' })">WSFinder</span>)
          </center>
          <hr>
          <b-row class="row justify-content-center" v-if="auth.profile.service != 'pro'">
            <wsfinder-item  v-for="dashboard_wsf in WSF" :key="dashboard_wsf.index" :wsf="dashboard_wsf" :wsf_pong_list="wsf_pong_list"></wsfinder-item>
          </b-row>
          <b-row  class="row justify-content-center" v-else>
            <p> wsfinder無し </p>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="auth && auth.license && auth.license.WFDetect.use == true">
        <b-card>
           <center>
             Web偽装・改ざん保護 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'integrity_detect' })">WFDetector</span>)
           </center>
           <hr>
           <b-row  class="row justify-content-center">
             <wfdetect-item  v-for="dashboard_wf in WF" :key="dashboard_wf.index" :wf="dashboard_wf"></wfdetect-item>
           </b-row>
         </b-card>
       </b-col>
      <b-col v-if="auth && auth.license && auth.license.WMDS.use == true">
        <b-card>
          <center>
            Webマルウェア配布対策 (with <span style="cursor:pointer; color:#08a0e6; font-weight:bold" @click="$router.push({ name : 'wmds_detect' })">WMDS</span>)
          </center>
          <hr>
          <b-row  class="row justify-content-center">
            <wmds-item  v-for="dashboard_wmds in WMDS" :key="dashboard_wmds.index" :wmds="dashboard_wmds"></wmds-item>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
